import { withLocalize } from "react-localize-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom";

/**
 * Utility component for Fallback redirections where parent component is not wrapped with localize.
 */
const FallbackRedirect = (
	props: LocalizeContextProps & { redirectPath: string }
) => {
	return (
		<Redirect
			to={`/${props.activeLanguage?.code ?? "en"}${props.redirectPath}`}
		/>
	);
};

export default withLocalize(FallbackRedirect);
